'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useReducedMotion } from 'motion/react';

/** Matches the serif heading on the sign-up page. */
export const SETUP_HEADING_CLASS = 'font-ivar text-2xl leading-tight font-normal tracking-tight text-gray-800 md:text-[28px]';
interface RevealTextProps {
  text: string;
  className?: string;
  /** Seconds before the first word appears. */
  delay?: number;
  /** Seconds between words. */
  stagger?: number;
  as?: 'h1' | 'h2' | 'p' | 'span';
}

/**
 * Word-by-word blur-in, so Clai's questions read like they are being spoken.
 * Screen readers get the full sentence at once.
 */
export function RevealText(t0) {
  const $ = _c(16);
  const {
    text,
    className,
    delay: t1,
    stagger: t2,
    as: t3
  } = t0;
  const delay = t1 === undefined ? 0 : t1;
  const stagger = t2 === undefined ? 0.035 : t2;
  const as = t3 === undefined ? "span" : t3;
  const reduceMotion = useReducedMotion();
  const Tag = motion[as];
  let t4;
  let t5;
  if ($[0] !== Tag || $[1] !== as || $[2] !== className || $[3] !== delay || $[4] !== reduceMotion || $[5] !== stagger || $[6] !== text) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const words = text.split(/(\s+)/);
      if (reduceMotion) {
        const Plain = as;
        let t6;
        if ($[9] !== Plain || $[10] !== className || $[11] !== text) {
          t6 = <Plain className={className}>{text}</Plain>;
          $[9] = Plain;
          $[10] = className;
          $[11] = text;
          $[12] = t6;
        } else {
          t6 = $[12];
        }
        t5 = t6;
        break bb0;
      }
      let t6;
      if ($[13] !== delay || $[14] !== stagger) {
        t6 = {
          visible: {
            transition: {
              staggerChildren: stagger,
              delayChildren: delay
            }
          }
        };
        $[13] = delay;
        $[14] = stagger;
        $[15] = t6;
      } else {
        t6 = $[15];
      }
      t4 = <Tag className={className} aria-label={text} initial="hidden" animate="visible" variants={t6} data-sentry-element="Tag" data-sentry-component="RevealText" data-sentry-source-file="reveal-text.tsx">{words.map(_temp)}</Tag>;
    }
    $[0] = Tag;
    $[1] = as;
    $[2] = className;
    $[3] = delay;
    $[4] = reduceMotion;
    $[5] = stagger;
    $[6] = text;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  return t4;
}
function _temp(word, i) {
  return /^\s+$/.test(word) ? <span key={i}>{word}</span> : <motion.span key={i} aria-hidden={true} className="inline-block" variants={{
    hidden: {
      opacity: 0,
      y: 6,
      filter: "blur(6px)"
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 0.35,
        ease: "easeOut"
      }
    }
  }}>{word}</motion.span>;
}